import { faqData } from '@/mocks/comicData';

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10 text-center">
          {faqData.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqData.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70"
            >
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-accent-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-6">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}